module.exports = __webpack_public_path__ + "img/wxcode.17a1eb60.jpg";